<template>
  <div >
    <div v-if="about.length>0">
    <div
      style="font-family:Titillium Web;line-height: 1.0;background:black;"
      class="p-3 ml-1 mr-1  shadow-lg rounded-lg animate__animated animate__zoomIn"
      :style="`${$store.state.data.layout.background_card2}`"
    >
      <br />
      <div id="atas"></div>
      <a :href="about[0].github">
        <button
          type="button"
          class="btn btn-sm btn-style9 float-right"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
          style="margin-left:5px;padding:3px;padding-top:0px;padding-bottom:0px;"
        >
          <img src="https://upload.egov.balangankab.go.id/svg/social-github-circular.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
        </button>
      </a>
      <a :href="about[0].linkedin">
        <button
          type="button"
          class="btn btn-sm btn-style9 float-right"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
          style="margin-left:5px;padding:3px;padding-top:0px;padding-bottom:0px;"
        >
        <img src="https://upload.egov.balangankab.go.id/svg/social-linkedin-circular.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
        </button>
      </a>
      <a :href="about[0].instagram">
        <button
          type="button"
          class="btn btn-sm btn-style9 float-right"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
          style="margin-left:5px;padding:3px;padding-top:0px;padding-bottom:0px;"
        >
         <img src="https://upload.egov.balangankab.go.id/svg/social-instagram.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
        </button>
      </a>
      <a :href="about[0].facebook">
        <button
          type="button"
          class="btn btn-sm btn-style9 float-right"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
          style="margin-left:5px;padding:3px;padding-top:0px;padding-bottom:0px;"
        >
        <img src="https://upload.egov.balangankab.go.id/svg/social-facebook.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
        </button>
      </a>
      <p class="pl-3 font-bold text-lg underline italic">{{about[0].title}}</p>
      <p class="pl-3 font-bold text-2xl">{{about[0].nama}}</p>
      <span class="float-right italic font-bold">{{about[0].wilayah}}</span>
      <div class="pl-3 pr-3">
        <hr class="style4 mt-4 mb-4" />
      </div>
      <br />
      <div style="line-height: 1.5;" class="p-3 rounded-lg text-lg" v-html="about[0].tentang">
      </div>
       <button
          type="button"
          class="btn btn-sm btn-style9 float-right underline italic mr-2"
          @click="$router.push('/a-4/portofolio')"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
          style=""
        >
          PORTOFOLIO !
          <img src="https://upload.egov.balangankab.go.id/svg/pencil.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
        </button>
        <br>
        <br>
        <br>
    </div>
    <!--  -->
    <br />
    <div
      style="font-family:Titillium Web;line-height: 1.0;background:black;"
      class="p-3 ml-1 mr-1 bg-white shadow-lg rounded-lg animate__animated animate__zoomIn"
    >
      <p class="pl-3 font-bold text-lg underline italic">PENGALAMAN KERJA</p>
      <div class="row p-3" >
        <div class="col-12">
          <div class="row" v-for="(item, index) in pengalamans" :key="index+'pengalamns'">
            <!--  -->
            <div class="col-4 mt-2">{{item.lama_kerja}}</div>
            <div class="col-8 mt-2">
              <p class="font-bold">{{item.posisi}}</p>
              <p class="italic">{{item.tempat_kerja}}</p>
            </div>
          </div>
        </div>
      </div>
      <button
        type="button"
        class="btn btn-sm btn-style9 underline italic ml-2"
        @click="$router.push('/a-4/project')"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
        style=""
      >
        My Projects
         <img src="https://upload.egov.balangankab.go.id/svg/pencil.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
      </button>
    </div>
    <br />
    <div
      style="font-family:Titillium Web;line-height: 1.0;background:black;"
      class="p-3 ml-1 mr-1 bg-white shadow-lg rounded-lg animate__animated animate__zoomIn"
    >
      <p class="pl-3 font-bold text-lg underline italic">EDUCATION</p>
      <div class="row p-3">
        <div class="col-12">
          <div class="row" v-for="(item, index) in pendidikans" :key="index+'pendidikans'">
            <!--  -->
            <div class="col-4 mt-2">{{item.lama_pendidikan}}</div>
            <div class="col-8 mt-2">
              <p class="font-bold">{{item.pendidikan}}</p>
              <p class="italic">{{item.sekolah}}</p>
            </div>
            <!--  -->
          </div>
        </div>
        <!--  -->
        <div class="col-12">
          <br>
         <button
        type="button"
        class="btn btn-sm btn-style9 underline italic"
        @click="$router.push('/a-4/sertifikat')"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
        style=""
      >
        My Certificates
        <img src="https://upload.egov.balangankab.go.id/svg/pencil.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
      </button>
        </div>
      </div>
    </div>
    
    <h1 style="font-size:1px;opacity:0.1;">Tentang TA_Maliki / Taufik Akbar Maliki</h1>
    <br />

    <a href="https://akbarmaliki.github.io/portofolio/" style="font-size:1px;opacity:0.1;">-</a>
    <a href="https://akbarmaliki.github.io/portofolio/contact" style="font-size:1px;opacity:0.1;">contact</a>
    <a href="https://akbarmaliki.github.io/portofolio/about" style="font-size:1px;opacity:0.1;">about</a>
    <a href="https://akbarmaliki.github.io/portofolio/coffe" style="font-size:1px;opacity:0.1;">coffe</a>
    <a href="https://akbarmaliki.github.io/portofolio/portofolio" style="font-size:1px;opacity:0.1;">portofolio</a>
    <a href="https://akbarmaliki.github.io/portofolio/project" style="font-size:1px;opacity:0.1;">project</a>
    <a href="https://akbarmaliki.github.io/portofolio/sertifikat" style="font-size:1px;opacity:0.1;">sertifikat</a>
  </div>
  </div>
</template>
<script>
import autophp from '@/plugins/autophp';
let sdb = new autophp();
let urlnya="https://gis.officialapp.my.id";
import axios from 'axios'
export default{
  layout:'a-4',
  data(){
    return{
      about:[],
      pengalamans:[],
      pendidikans:[],
      header:[]
    }
  },
  // async asyncData({isDev, route, store, env, params, query, req, res, redirect, error}) {
  //   var data=[]
  //   const result = await axios.post(urlnya+'/auth/getHeader.php?id=1&keytoken=app_portofolio_about&apikey=nuxtapi');
  //   store.state.data=result.data
  //   data=result.data;
  //    return {
  //      header:data
  //    }
  // },
  mounted() {
    sdb.collection("app_portofolio_about",false,urlnya).doc().select(`select * from app_portofolio_about where iduser='${this.$store.state.id}'`).then(res => {
        this.about=res;
        this.$forceUpdate();
    });
     sdb.collection("app_portofolio_pengalaman",false,urlnya).doc().select(`select * from app_portofolio_pengalaman where iduser='${this.$store.state.id}'`).then(res => {
        this.pengalamans=res;
        this.$forceUpdate();
    });
     sdb.collection("app_portofolio_pendidikan",false,urlnya).doc().select(`select * from app_portofolio_pendidikan where iduser='${this.$store.state.id}'`).then(res => {
        this.pendidikans=res;
        this.$forceUpdate();
    });
    
  },
}
</script>
